import React, { useState, useEffect } from 'react'
import Form from './Form'
import Img from '../general/Image'
import useContent from '../../utils/content'
import { useDataQuery } from '../../hooks/useDataQuery'

// eslint-disable-next-line react/react-in-jsx-scope
// eslint-disable-next-line react/prefer-stateless-function
const Teaser = () => {
  const [isDesktop, setIsDesktop] = useState(false)

  useEffect(() => {
    if (window.innerWidth > 767) {
      setIsDesktop(true)
    }
    window.addEventListener('resize', () => {
      if (window.innerWidth > 767) {
        setIsDesktop(true)
      } else {
        setIsDesktop(false)
      }
    })
  }, [])

  const content = useContent(useDataQuery())

  const getClearPhoneNumber = raw => {
    const filterArr = [' ', '(', ')', '-']
    const resultString = raw.split('').filter(sym => !filterArr.includes(sym))
    // console.log('resultString: ', resultString.join(''))
    return resultString.join('')
  }

  let mapUrl = ''
  if (content.address) {
    mapUrl = `https://maps.google.com/?q=${content.address
      .replace(' ', '%20')
      .replace(',', '')
      .replace('<br>', '')}`
  }

  return (
    <section className="teaser">
      <Img className="teaser_img" src={content.teaserImage} />
      <div className="container-small">
        <div className="teaser_cont">
          <h1 className="teaser_cont_title">
            {content.title}
            <span
              className="teaser_cont_title-red"
              dangerouslySetInnerHTML={{ __html: content.subTitle }}
            />
          </h1>
          {content.teaserWidgetUrl && <Form />}
          <div className="teaser_cont_contacts">
            {isDesktop && (
              <div className="teaser_cont_contacts_item">
                <img src="/icons/phone.svg" alt="" />
                <a
                  href={`tel:${content.phoneNumbers[1] ||
                    content.phoneNumbers[0]}`}
                >
                  <p>{content.teaserPhone}</p>
                </a>
              </div>
            )}
            <div className="teaser_cont_contacts_item">
              {isDesktop && <img src="/icons/address.svg" alt="" />}
              <a href={content.mapLink} target="_blank">
                <p>{content.teaserAddress}</p>
              </a>
            </div>
          </div>
        </div>
        {!isDesktop && (
          <a
            href={`tel:${getClearPhoneNumber(content.teaserPhone)}`}
            className="teaser_mob_mobilo"
          >
            <p>{content.teaserPhone}</p>
            <img src="/icons/phone-in-circle.svg" alt="" />
          </a>
        )}
      </div>
    </section>
  )
}

export default Teaser
